import { RewardModel, RewardModelWithChance } from '@shared/types';

export const getMapValues = <K, V>(map: Map<K, V>) => Array.from(map.values());

export const transformRewardsFromObjectToMap = (
  rewardsWithChance: Record<string, number>,
  rewardsData: RewardModel[]
): RewardModelWithChance[] => {
  return rewardsData.map((reward) => {
    return {
      ...reward,
      chance: rewardsWithChance[reward.id],
    };
  });
};

export const transformRewardsFromMapToObject = (rewards: RewardModelWithChance[]) =>
  rewards.reduce(
    (rewardsMap, { id, chance }) => {
      return {
        [id]: chance,
        ...rewardsMap,
      };
    },
    {} as Record<string, number>
  );
